// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZMfM","index":"styles_index__2VLhI"};